import React from 'react';
import PropTypes from 'prop-types';

import styles from './Link.module.css';

const noop = () => {};

const Link = ({ active, name, onClick, tag: Tag, style, className, simple }) => {
  const activeClass = active ? styles.btnDrawActive : '';
  const linkStyle = { pointerEvents: onClick ? undefined : 'none', ...style };
  return (
    <span className={`${styles.btnDraw} ${activeClass} ${className} ${simple ? styles.btnDrawSimple : styles.btnDrawFilled}`} style={linkStyle} onClick={onClick || noop}>
      <Tag>{name}</Tag>
    </span>
  );
};

Link.propTypes = {
  name: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  style: PropTypes.object.isRequired,
  tag: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

Link.defaultProps = {
  className: '',
  active: false,
  style: {},
  tag: 'span',
};

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link.js